
const Update = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M19.479 10.092c-.212-3.951-3.473-7.092-7.479-7.092s-7.267 3.141-7.479 7.092c-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408zm-12.479 3.658h1.25c0-2.071 1.68-3.75 3.75-3.75.997 0 1.903.393 2.574 1.028l-.835.93c-.45-.438-1.064-.708-1.739-.708-1.378 0-2.5 1.121-2.5 2.5h1.25l-1.859 2.07-1.891-2.07zm8.75 0c0 2.071-1.68 3.75-3.75 3.75-.997 0-1.903-.393-2.574-1.028l.835-.93c.45.437 1.063.708 1.739.708 1.378 0 2.5-1.121 2.5-2.5h-1.25l1.859-2.07 1.891 2.07h-1.25z" />
  </svg>
);

export default Update;
